"use strict";
import Splide from "@splidejs/splide";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const gallerySlider = document.querySelector(
            ".o-about-gallery__items.splide"
        );
        if (!gallerySlider) return;

        const splide = new Splide(gallerySlider, {
            type: "loop",
            perPage: 5,
            autoplay: false,
            interval: 5000,
            speed: 800,
            drag: false,
            pauseOnHover: true,
            arrows: false,
            pagination: false,
            gap: "1.5rem",
            autoWidth: true,
            autoHeight: true,
            breakpoints: {
                1024: {
                    perPage: 3,
                    drag: true,
                    autoplay: true,
                    autoWidth: false,
                    autoHeight: false,
                },
                680: {
                    perPage: 2,
                },
            },
        });

        splide.mount();
    });
}
